import { render, staticRenderFns } from "./QrcdAddMain.vue?vue&type=template&id=1f0065fe&scoped=true&"
import script from "./QrcdAddMain.vue?vue&type=script&lang=js&"
export * from "./QrcdAddMain.vue?vue&type=script&lang=js&"
import style0 from "./QrcdAddMain.vue?vue&type=style&index=0&id=1f0065fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0065fe",
  null
  
)

export default component.exports